import { getAllFilesDetails } from "../../../apis/sharedFolderApi";
import { ProjectService } from "../../../service/PegaService";
import LoadingOverlay from "react-loading-overlay-ts";
import React, { useEffect, useState } from "react";
import { changeDateFormat, redirectUnallocatedLinksToArtworkStatus } from "../../../utils";
import { useParams } from "react-router-dom";
import "primeicons/primeicons.css";
import JobList from "./JobList";
import "./index.scss";
import { CopyXmlData } from "./util";
import { SpecialProjectAction } from "../../../store/actions/ProjectSetupActions";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

function convertJobList(FileDetails) {
  let keyCounter = 1;

  function traverse(job) {
    const newObj = {
      children: [],
      data: job?.Data,
      key: keyCounter++,
    };

    job?.JobNameList?.forEach((jobName, index) => {
      const updatedData = {
        ...jobName?.Data,
        firstParentKey: newObj?.key,
      };
      const childObj = {
        children: [],
        data: updatedData,
        firstParentKey: newObj?.key,
        key: newObj?.key * 10 + index + 1,
      };

      if (job.Data.Filename === "Custom Fullkit") {
        childObj.children = jobName?.FileList?.map((grandChildData, indx) => ({
          data: {
            Date: "",
            Filename: grandChildData?.TaskName,
            Filepath: "",
            Owner: "",
            AWMTaskID: grandChildData?.AWMTaskID,
            Version: "",
          },
          children: grandChildData?.FileList?.map((file, in_dex) => ({
            data: { ...file.Data, ParentTaskId: jobName?.Data?.Parent_AWM_Task_ID },
            key: (childObj.key * 10 + indx + 1) * 10 + in_dex + 1,
            parentKey: newObj?.key,
            keyCode: childObj?.key,
          })),
          key: childObj.key * 10 + indx + 1,
        }));

        newObj?.children?.push(childObj);
      } else {
        jobName?.FileList?.forEach((file, i) => {
          childObj?.children?.push({
            data: {
              ...file?.Data,
              keyCode: childObj?.key,
              parentKey: newObj?.key,
              Date: file?.Data?.Date && changeDateFormat(file?.Data?.Date),
            },
            parentKey: newObj?.key,
            keyCode: childObj?.key,
            key: childObj?.key * 10 + i + 1,
          });
        });

        newObj?.children?.push(childObj);
      }
    });

    return newObj;
  }

  return FileDetails?.map(traverse);
}

function FilesFolderCompo(props) {
  let columnNamesJson = localStorage.getItem("filesAllColumnNames");
  const [JobListData, setJobListData] = useState([]);
  const [ProjectDetalis, setProjectDetalis] = useState({});
  const columnNames = JSON.parse(columnNamesJson);
  const { view, loader, setLoader, setAccessType, wrapFilename, setWrapFilename, refreshTrigger } =
    props;

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const currentUrl = location?.pathname;

  let { ProjectID } = useParams();
  if (columnNames === null) {
    const columnNames = ProjectService.getFilesAllColumnNames();
    localStorage.setItem("filesAllColumnNames", JSON.stringify(columnNames));
  }

  // Helper function to build file metadata structure
  const buildFileStructure = (file) => {
    const fileData = {
      Owner: file?.Owner || "",
      ViewPFURL: file?.ReadOnlyURL || "",
      Email: file?.Email || "",
      Version: file?.Version || "1",
      Filename: file?.Filename || "",
      FileID: file?.FileID || "",
      AWMTaskID: "",
      Filepath: file?.Filepath || "",
      Date: file?.Timestamp || "",
    };

    return {
      Data: {
        ...fileData,
        VersionList: [fileData],
      },
    };
  };

  useEffect(() => {
    if (props.accessSecurityMatrix) {
      fetchDependencyMappingTabDetails(ProjectID);
    }
  }, [refreshTrigger]);

  const fetchDependencyMappingTabDetails = async (projectId) => {
    setLoader(true);
    const { response, specialProjectFlag, AccessType } = await getAllFilesDetails(
      projectId,
      props.userAccessPayLoad,
    );
    setAccessType(AccessType);
    dispatch(SpecialProjectAction(specialProjectFlag));
    redirectUnallocatedLinksToArtworkStatus(currentUrl, specialProjectFlag, navigate);

    if (response) {
      const updatedJobList = await CopyXmlData(response);
      const additionalFiles = response?.AdditionalFiles || [];
      
      // Build dynamic Additional Files structure
      let dynamicAdditionalFilesData = [];
      if (additionalFiles.length > 0) {
        const fileList = additionalFiles.map(buildFileStructure);

        dynamicAdditionalFilesData = [
          {
            JobNameList: [
              {
                Data: {
                  Filename: "Additional files uploaded",
                  Filepath: "",
                },
                FileList: fileList,
              },
            ],
            Data: {
              Filename: "Additional files uploaded",
              Folder: "AdditionalFiles",
            },
          },
        ];
      }

      const data = convertJobList([...updatedJobList, ...dynamicAdditionalFilesData]);
      setProjectDetalis(response?.ProjectDetails);
      props?.setProjectName(response?.ProjectDetails);
      setJobListData(data);
      
      // Reset expandedKeys to prevent tree collapse with new data
      props?.setExpandedKeys([]);
    }
    setLoader(false);
  };

  return (
    <>
      {loader ? (
        <LoadingOverlay active={true} spinner text="" className="overlay-loader" />
      ) : (
        <>
          <JobList
            {...props}
            view={view}
            JobListData={JobListData}
            ProjectDetalis={ProjectDetalis}
            wrapFilename={wrapFilename}
            setWrapFilename={setWrapFilename}
          />
        </>
      )}
    </>
  );
}

export default FilesFolderCompo;
